/**
 * Comparables & Borrower Exit History Enums
 *
 * Closed-system reference data captured by the closer / underwriter.
 * No external scraping — all data is entered manually.
 *
 * @see Issue #1467 - Comparables + Exit History
 */

/**
 * Kind of comparable: SALE drives purchase / value analysis,
 * RENT drives DSCR analysis. The field set differs slightly.
 */
export enum CaseComparableKind {
  SALE = 'SALE',
  RENT = 'RENT',
}

/**
 * Outcome of a prior loan exit. Used by the BorrowerTier classifier
 * (Issue #1469) to weight historical performance.
 */
export enum BorrowerExitOutcome {
  /** Loan funded but not yet exited (rare on this row — used when tracking) */
  FUNDED = 'FUNDED',
  /** Loan paid off in full at maturity (positive signal) */
  PAID_OFF = 'PAID_OFF',
  /** Borrower defaulted (negative signal) */
  DEFAULTED = 'DEFAULTED',
  /** Property sold and loan retired (positive signal) */
  SOLD = 'SOLD',
}
